module.exports = require("vuetify/lib/components/VIcon");